<template>
  <div>
    <div class="top">
      <div class="text">
        <div class="title">
          Gang Survey
        </div>
        <div class="value">
          A hybrid methodology of qualitative and quantitative research methodologies. Part 1: a self-completed, standardized questionnaire is administered under moderator supervision. Every participant receives same instructions and information.
          Part 2: A group discussion is held on the most important qualitative questions--based on their quantitative answers in Part 1.

        </div>
        <div><button @click="contact">REQUEST A BID</button></div>
      </div>
    </div>

    <div class="recommended">
      <div class="title">Gang Surveys provide more reliable information, and less inconsistency due to possible fieldwork control issues. Gang Survey advantages:
      </div>
      <div class="value">
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/gangSurvey/survey1.png">
          <div class="text">Standardized/uniform conditions for the entire group</div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/gangSurvey/survey2.png">
          <div class="text">Less efforts/lower costs through larger groups, who are simultaneously interviewed under the same conditions
          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/gangSurvey/survey3.png">
          <div class="text">
            Economic alternative to individual interviews
          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/gangSurvey/survey4.png">
          <div class="text">Combination of closed and open-end questions possible
          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/gangSurvey/survey5.png">
          <div class="text">Uniformed situation for all respondents
          </div>
        </div>
      </div>
    </div>

    <div class="Surveys">
      <div class="title">
        Gang Surveys are recommended for:
      </div>
      <div class="value">
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/gangSurvey/newProductTesting.jpg">
          <div class="text">New Product Testing</div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/gangSurvey/innovationConcepting.jpg">
          <div class="text">Innovation Concepting </div>
        </div>
      </div>
    </div>

    <!-- Case Study -->
    <case-study />

  </div>
</template>

<script>
import CaseStudy from "@/components/caseStudy";
import { advertisementFlow } from "@/api/api";

export default {
  data() {
    return {};
  },
  created() {
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  components: {
    CaseStudy
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "gangSurvey",
          source: "",
          information: "Solutions_gangSurvey"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "gangSurvey",
          source: this.$route.query.source,
          information: "Solutions_gangSurvey"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    contact() {
      let routeData = this.$router.resolve({ path: "/contact?source=bid" });
      window.open(routeData.href, "_blank");
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    }
  }
};
</script>

<style lang="scss" scoped>
.top {
  padding: 140px 200px;
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/gangSurvey/surveybg.png");
  background-size: cover;
  // height: 600px;
  .text {
    width: 60%;
    .title {
      width: 70%;
      font-size: 50px;
      font-weight: 700;
      margin-bottom: 25px;
      color: #fff;
    }
    .value {
      font-size: 20px;
      color: #fff;
    }
    button {
      border: none;
      background-color: #2cb1e9;
      color: #fff;
      font-size: 20px;
      border-radius: 10px;
      margin-top: 20px;
      padding: 10px;
    }
  }
}
.recommended {
  padding: 80px 120px;
  text-align: center;
  .title {
    font-size: 40px;
    font-weight: 700;
    padding-bottom: 60px;
  }
  .value {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    // padding: 50px;
    .box {
      width: 30%;
      img {
        width: 100px;
        margin-bottom: 30px;
      }
      .text {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 50px;
      }
    }
  }
}
.Surveys {
  padding: 50px 120px;
  .title {
    font-size: 40px;
    font-weight: 700;
  }
  .value {
    display: flex;
    flex-wrap: wrap;
    padding: 50px;
    justify-content: space-around;
    .box {
      width: 30%;
      img {
        width: 100%;
      }
      .text {
        text-align: center;
        font-size: 30px;
        margin-top: 15px;
        // font-weight: 700;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .top {
    padding: 90px 100px;
    .text {
      width: 100%;
      .title {
        width: 80%;
        font-size: 110px;
      }
      .value {
        font-size: 70px;
      }
      button {
        font-size: 70px;
        padding: 10px 20px;
      }
    }
  }
  .recommended {
    padding: 80px 100px;
    .title {
      font-size: 80px;
    }
    .value {
      .box {
        width: 90%;
        img {
          width: 400px;
        }
        .text {
          font-size: 70px;
          margin-bottom: 200px;
        }
      }
    }
  }
  .Surveys {
    padding: 80px 100px;
    .title {
      font-size: 80px;
    }
    .value {
      .box {
        width: 90%;
        .text {
          font-weight: 700;
          font-size: 70px;
        }
      }
    }
  }
}
</style>